require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/babel-loader/lib/index.js?{\"presets\":[\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-es2015/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-stage-1/lib/index.js\",[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"cacheDirectory\":true}!./new-page.js") })
        }
      }, "component---src-pages-new-page-js");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=component---src-pages-new-page-js!./src/pages/new-page.js
// module id = 319
// module chunks = 231608221292675